import { Navigate } from 'react-router';
import { ROUTES } from '../../../constants/RouteNameMapping';

/** Auditor settings live under Manage Access; this keeps bookmarks to the old URL working. */
export function AuditorConfigRedirect() {
  return (
    <Navigate
      to={`/${ROUTES.ADMIN_PANEL}/${ROUTES.ADMIN_PANEL_MANAGE_ACCESS}/${ROUTES.ADMIN_PANEL_MANAGE_ACCESS_AUDITOR_SETTINGS}`}
      replace
    />
  );
}
